const initMiniConfig = () => {
  if (window.ydk) {
    // 配置小程序导航
    window.ydk.setPageConfig({
      title: '',
      navigationStyle: 'custom', // 当行交给前端自定义处理
      canGoBack: false, // 不显示后退按钮
    });
    // 设置胶囊菜单按钮
    window.ydk.setMenus({
      menus: [
        {
          title: '添加到桌面',
          icon: 'https://ydlunacommon-cdn.nosdn.127.net/1c1fc5eded2e85622de7180b465b5ca6.png',
          darkIcon: 'https://ydlunacommon-cdn.nosdn.127.net/c7b04d3801aa99cdfa975f2ad105bf01.png',
        },
        {
          title: '反馈',
          icon: 'https://ydlunacommon-cdn.nosdn.127.net/68626905a19d84fb6f528c503d23943e.png',
          darkIcon: 'https://ydlunacommon-cdn.nosdn.127.net/acdcdddef4b2f1541c131bd6b362f624.png',
        },
        {
          title: '分享',
          icon: 'https://shared.youdao.com/market/souti/japanese50/1.1.7/dist/static/ic_nav_applet_more_share@3x.png',
          darkIcon: 'https://shared.youdao.com/market/souti/japanese50/1.1.7/dist/static/ic_nav_applet_more_share_dark@3x.png',
        },
      ],
    });
    // 胶囊按钮点击处理事件
    window.ydk.onMenuClick({
      complete(data) {
        switch (data.index) {
          case 0:
            window.ydk.addToDesktop({
              link:
                [
                  'https://c.youdao.com/market/openDictProgram/index.html?title=',
                  encodeURIComponent('日语五十音图'),
                  '&icon=',
                  encodeURIComponent('https://shared.youdao.com/market/souti/japanese50/1.2.1/dist/static/ic_wushiyin_logo_144.png'),
                ].join(''),
              success: () => {},
            });
            break;
          case 1:
            window.ydk.openInWebView({
              url: 'https://c.youdao.com/dict/feedback/index.html?callback=false&from=default',
              success: () => {},
            });
            break;
          case 2:
            window.ydk.share({
              type: '',
              silence: false,
              title: '日语五十音图',
              desc: '边学边练，轻松搞定五十音图～',
              imgUrl: 'https://shared.youdao.com/market/souti/japanese50/1.2.1/dist/static/ic_wushiyin_logo_480.png',
              link: 'https://c.youdao.com/dict/miniprogram/japanese50.html#/index',
              success(res) {
                console.log(res);
              },
              fail(res) { console.log(res); },
            });
            break;
          default:
            break;
        }
      },
    });
  }
  // 微信环境
  window.ydk.share({
    silence: true,
    title: '日语五十音图',
    desc: '边学边练，轻松搞定五十音图～',
    imgUrl: 'https://shared.youdao.com/market/souti/japanese50/1.2.1/dist/static/hiragana/%E3%81%82.png',
    link: 'https://c.youdao.com/dict/miniprogram/japanese50.html#/index',
  });
};

export default initMiniConfig;
